'use strict';

var progress = require('../../utils/progress');
var validInputIndicator = require('../../validation/valid-input-indicator');
var captcha = require('../../spam/captcha');
var isClickOrSpaceOrEnter = require('../../utils/util').isClickOrSpaceOrEnter;
var validator = require('../../utils/validator');

/**
 * Highlights the terms and conditions container when terms are not accepted.
 * When the terms are accepted, the highlight is removed.
 * @param {JQuery} $newsletterContainer
 */
const highlightTermsError = $newsletterContainer => {
    const $acceptTerms = $newsletterContainer.find('.accept-terms');
    $acceptTerms.find('.custom-checkbox-container').addClass('accept-terms-error');
    $acceptTerms.find('.checkbox-input').one('click', e => {
        $newsletterContainer
            .find('.status')
            .fadeOut(300, () =>
                $(e.currentTarget).siblings('.custom-checkbox-container').removeClass('accept-terms-error')
            );
    });
};

/**
 * Displays the "terms and conditions not accepted" error
 * @param {JQuery} $newsletterContainer
 */
const showTermsError = $newsletterContainer => {
    const message = $newsletterContainer.data('terms-not-accepted-msg');
    $('<div class="status message error-form">' + message + '</div>').insertAfter(
        $newsletterContainer.find('.newsletter.close')
    );
    highlightTermsError($newsletterContainer);
};

/**
 * Uncollapses the newsletter form.
 * @param {JQuery} $footerNewsletter
 */
const uncollapse = $footerNewsletter => {
    const $emailContainer = $footerNewsletter.find('.newsletter-email-container');
    const $emailInput = $emailContainer.find('.form-row-email input');
    $emailInput.attr('placeholder', $emailContainer.data('expanded-placeholder'));
    $footerNewsletter.find('.collapsed').slideDown().removeClass('collapsed').addClass('expanded');

    $footerNewsletter.find('.newsletter.close').show();
    $emailInput.addClass('open-newsletter-form');
    $footerNewsletter.find('.footer-section-description').addClass('visibility-hidden');
};

/**
 * Attaches an event to the newsletter container close icon that collapses the newsletter form.
 *
 * @param {jQuery} $footerNewsletter
 */
const initCollapseEvent = $footerNewsletter => {
    $('.ajax-newsletter-form').on('click keypress', '.newsletter.close', e => {
        if (isClickOrSpaceOrEnter(e)) {
            const $emailContainer = $footerNewsletter.find('.newsletter-email-container');
            const $emailInput = $emailContainer.find('.form-row-email input');

            $emailInput.val('').focusout();
            $footerNewsletter.find('.validation-error').removeClass('validation-error');
            $footerNewsletter.find('.error').removeClass('error');

            const $collapsibleContainer = $footerNewsletter.find('.expanded');
            $collapsibleContainer.slideUp(400, () => {
                $footerNewsletter.find('.newsletter.close').hide();
                $emailInput.removeClass('open-newsletter-form');
                $emailInput.siblings('.show-valid').hide();
                $emailInput.attr('placeholder', $emailContainer.data('collapsed-placeholder'));
                $footerNewsletter.find('.footer-section-description').removeClass('visibility-hidden');
                $footerNewsletter.find('.status.message.error-form').hide();
                $footerNewsletter.find('.icon-arrow_next').show();
                $footerNewsletter.find('.error-msg').remove();
                $collapsibleContainer.removeClass('expanded').addClass('collapsed');
                $('.newsletter-email-container').show();
            });
        }
    });
};

/**
 * Handles the newsletter subscription process via the footer newsletter form.
 * @param {JQuery} $footerNewsletter
 * @param {JQuery} $actionElement - element that triggered the event
 */
const handleFooterSubscribe = ($footerNewsletter, $actionElement) => {
    const $form = $actionElement.closest('form');
    if (!$form.valid()) {
        return false;
    }
    $form.find('.status').remove();
    const hasAcceptedTerms =
        $form.find('.js-accept-terms-hidden').length > 0
            ? true
            : $form.find('.accept-terms .checkbox-input').prop('checked');

    if (!hasAcceptedTerms) {
        showTermsError($form);
        return;
    }

    const url = $form.attr('action');
    const email = $form.find('input.input-email').val();
    const $genderInput = $form.find('.newsletter-gender');
    if ($genderInput.length) {
        const gender = $actionElement.attr('value');
        $genderInput.val(gender);
    }

    progress.show();
    $.ajax({
        url: url,
        type: 'POST',
        dataType: 'json',
        data: $form.serialize(),
        success: data => {
            if (data.success) {
                $footerNewsletter
                    .find('.nlsubscribe-form')
                    .replaceWith('<div class="status message success-form">' + data.msg + '</div>');

                $footerNewsletter.find('.footer-section-description').hide();

                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'newsletterSignup_footer',
                        newsletterSignupStep: 'NewsletterBox'
                    });
                }

                const $currentNewsletter = $footerNewsletter.filter(':visible');
                if (!$currentNewsletter.isInViewport(200)) {
                    $('html, body').animate(
                        {
                            scrollTop: $currentNewsletter.offset().top - $currentNewsletter.outerHeight()
                        },
                        300
                    );
                }
                if (data.additionalText) {
                    $footerNewsletter.find('.success-form').append(data.additionalText);
                }
            } else if (data.valueError) {
                $('<div class="status message error-form">' + data.valueError + '</div>').insertAfter(
                    $footerNewsletter.find('.newsletter.close')
                );

                if (data.termsError) {
                    highlightTermsError($form);
                }
                captcha.resetCaptcha($form[0]);
            } else {
                $('<div class="status message error-form">' + Resources.NEWSLETTER_ERROR + '</div>').insertAfter(
                    $footerNewsletter.find('.newsletter.close')
                );
                captcha.resetCaptcha($form[0]);
            }
        },
        error: data => {
            $('<div class="status message error-form">' + Resources.NEWSLETTER_ERROR + '</div>').insertAfter(
                $footerNewsletter.find('.newsletter.close')
            );
            captcha.resetCaptcha($form[0]);
        },
        complete: () => progress.hide()
    });
};

/**
 * Initializes events on NL elements:
 */
function initializeEvents() {
    const $footerNewsletter = $('.footer-newsletter');
    const $ajaxNewsletterForm = $('.ajax-newsletter-form');
    initCollapseEvent($footerNewsletter);

    $ajaxNewsletterForm.on('click', '.form-row-email input', function (event) {
        uncollapse($footerNewsletter);
    });

    $ajaxNewsletterForm.on('click', '.newsletter-email-container .button.icon-arrow_next', function (event) {
        uncollapse($footerNewsletter);
    });

    $ajaxNewsletterForm.find('input[type="submit"], button[type="button"]').on('click', e => {
        e.preventDefault();
        const $actionElement = $(e.currentTarget);
        handleFooterSubscribe($footerNewsletter, $actionElement);
    });

    $ajaxNewsletterForm.on('click', '.flyin-buttons-row .button', function (e) {
        e.preventDefault();
        const $actionElement = $(e.currentTarget);
        handleFooterSubscribe($footerNewsletter, $actionElement);
    });

    // 1774 PAGE NEWSLETTER FOOTER
    $('.newsletter-1774 .form-row-email input').on('focus', function () {
        $(this).attr('placeholder', '');
    });

    $('.newsletter-1774 button[type="submit"]').on('click', function (e) {
        if ($('.accept-terms').hasClass('error')) {
            $('.accept-terms').removeClass('error');
        }
        var form = $(this).closest('form');
        var url = form.attr('action');
        e.preventDefault();
        // indicate progress
        progress.show1774Newsletter();

        if (!form.valid()) {
            progress.hide();
            return false;
        }

        $.ajax({
            url: url,
            type: 'POST',
            data: form.serialize(),
            success: function (returnedObj) {
                $('.newsletter-1774').find('.error-form').remove();
                if (returnedObj.success) {
                    const msg = returnedObj.msg || Resources.NEWSLETTER_SUCCESS;
                    $('.subscribe-1774-form').replaceWith('<div class="status message success-form">' + msg + '</div>');

                    if (window.dataLayer) {
                        window.dataLayer.push({
                            event: 'newsletterSignup_1774',
                            newsletterSignupStep: 'NewsletterBox'
                        });
                    }
                } else if (returnedObj.valueError) {
                    if (!$('.accept-terms').hasClass('error')) {
                        $('<div class="status message error-form">' + returnedObj.valueError + '</div>').insertAfter(
                            '.terms-label-container'
                        );
                        $('.accept-terms').addClass('error');
                    }
                    captcha.resetCaptcha(form[0]);
                } else if (returnedObj.error) {
                    const msg = returnedObj.msg || Resources.NEWSLETTER_ERROR;
                    $('<div class="status message error-form">' + msg + '</div>').insertBefore('.subscribe-1774-form');
                    captcha.resetCaptcha(form[0]);
                }
            },
            error: err => captcha.resetCaptcha(form[0]),
            complete: () => progress.hide()
        });
    });

    $('.newsletter-widget, .newsletter-widget-button').on('focus click', function (e) {
        const $element = $(this);

        $.ajax({
            url: $('.newsletter-widget').attr('action'),
            type: 'GET',
            success: data => {
                // Remove the previously loaded form, if it exists, to avoid IDs duplication
                $('#footer-newsletter').remove();

                $('.newsletter-email-container').hide();
                $element.closest('.newsletter-email-container').siblings('.ajax-newsletter-form').html(data);
                $element.addClass('visibility-hidden');
                $footerNewsletter.find('.footer-section-description').addClass('visibility-hidden');
                $('.footer-section-newsletter .button.close').show();
                $('body').trigger('newsletterfooter::newsletterFormLoaded');
            },
            complete: () => {
                const friendlyCaptcha = require('../../widgets/friendlyCaptcha');
                friendlyCaptcha.init('.frc-captcha');
                const $form = $ajaxNewsletterForm.children('form');
                captcha.resetCaptcha($form[0]);
                const newsletterForm = $('#footer-newsletter');
                const $smsSignUpCheckbox = $('#dwfrm_newsletter_acceptsmssignup');
                validator.init();
                const $inputSignUpSms = $('.input-signUp-sms-footer');
                if ($smsSignUpCheckbox.length) {
                    $smsSignUpCheckbox.on('click', function () {
                        if ($smsSignUpCheckbox[0].checked) {
                            $inputSignUpSms[0].style.display = 'block';
                        } else {
                            $inputSignUpSms[0].style.display = 'none';
                        }
                    });
                }
                newsletterForm.on('focusout', '.email', function () {
                    const val = $element.val();
                    if (!val) {
                        newsletterForm.valid();
                    }
                });
            }
        });
    });

    validInputIndicator.initValidIndicatorEvent({container: $footerNewsletter});
}

exports.init = () => {
    initializeEvents();
};
